import React, { ComponentProps } from 'react';
import { SONHTMLContent, Wysiwyg } from '../../../_lib/components/Wysiwyg';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { ContentParagraph, ContentParagraphModifier } from '../../../_lib/components/ContentParagraph';
import { asView } from '../../../_lib/ViewFetcher';

function LoginDescriptionDefault({ content, resourceReferencesToToUrls }: SONHTMLContent) {
  const { t } = useSonTranslation('LoginDescription');

  if (!content || content === '') {
    return <ContentParagraph modifier={ContentParagraphModifier.PADDING}>{t('noDataInfoText')}</ContentParagraph>;
  }

  return <Wysiwyg content={content} resourceReferencesToToUrls={resourceReferencesToToUrls} />;
}

export const LoginDescriptionDefaultView = asView(LoginDescriptionDefault);
export type LoginDescriptionDefaultView = ComponentProps<typeof LoginDescriptionDefaultView>;
